// Content anchors survive changes in translated text length above the viewport.
export function captureViewportAnchor(root,line=180){
 let best=null;
 for(const element of root.querySelectorAll('section[id],article[id],.section[id]')){
  const rect=element.getBoundingClientRect();
  if(rect.top<=line&&rect.bottom>line&&(!best||rect.top>=best.top))best={id:element.id,top:rect.top};
 }
 return best;
}
export function restoredViewportTop(anchor,root,current){
 const element=anchor&&root.getElementById(anchor.id);
 return element?Math.max(0,current+element.getBoundingClientRect().top-anchor.top):current;
}
